import React from 'react';
import { Button, Row, Col } from 'antd';

const FilterActionButtons = ({
  onApply,
  onReset,
  applyText = 'Apply',
  resetText = 'Reset',
  sideView = true,
  disabled = false,
}) => {
  if (!sideView) {
    return (
      <div style={{ display: 'flex', gap: 6, padding: '8px 12px', float: 'right' }}>
        <Button
          type="primary"
          disabled={disabled}
          className="display-center"
          onClick={onApply}
        >
          <div
            style={{
              display: 'flex',
              marginLeft: 'auto',
              marginRight: 'auto',
              gap: '6px',
            }}
            className="display-center"
          >
            <i style={{ fontSize: 16 }} className="ri-checkbox-circle-line"></i>
            <div>{applyText}</div>
          </div>
        </Button>
        <Button
          type="default"
          className="display-center reset-filter-button"
          onClick={onReset}
          style={{ height: 36 }}
        >
          {resetText}
        </Button>
      </div>
    );
  }

  return (
    <Row>
      <Col span={16}>
        <div style={{ margin: '8px' }}>
          <Button
            disabled={disabled}
            className="upload-document-button display-center w-100"
            onClick={onApply}
          >
            <div
              style={{
                display: 'flex',
                marginLeft: 'auto',
                marginRight: 'auto',
                gap: '6px',
              }}
              className="display-center"
            >
              <i style={{ fontSize: 16 }} className="ri-checkbox-circle-line"></i>
              <div>{applyText}</div>
            </div>
          </Button>
        </div>
      </Col>
      <Col span={8}>
        <div style={{ margin: '8px' }}>
          <Button
            className="display-center reset-filter-button w-100"
            onClick={onReset}
          >
            <div className="display-center">
              <div>{resetText}</div>
            </div>
          </Button>
        </div>
      </Col>
    </Row>
  );
};

export default FilterActionButtons;